module.exports = __webpack_public_path__ + "img/logo-parenting-hub.ae7767a.svg";